import { RouterStateSnapshot, ActivatedRouteSnapshot, Route } from '@angular/router';

import { BaseRouterStoreState, RouterStateSerializer } from '@ngrx/router-store';

export interface NgrxRoute extends Route {
  serializeData?: boolean;
  children?: NgrxRoute[];
}

type NgrxActivatedRouteSnapshot = {
  get children(): NgrxActivatedRouteSnapshot[];
  routeConfig: {
    serializeData?: boolean;
  };
} & ActivatedRouteSnapshot;

// removed data: ActivatedRouteSnapshot['data']; because we have issues with serializer in StoreRouter
export interface MinimalActivatedRouteSnapshot {
  routeConfig: ActivatedRouteSnapshot['routeConfig'];
  url: ActivatedRouteSnapshot['url'];
  params: ActivatedRouteSnapshot['params'];
  queryParams: ActivatedRouteSnapshot['queryParams'];
  fragment: ActivatedRouteSnapshot['fragment'];
  data: ActivatedRouteSnapshot['data'];
  outlet: ActivatedRouteSnapshot['outlet'];
  firstChild?: MinimalActivatedRouteSnapshot;
  children: MinimalActivatedRouteSnapshot[];
}

export interface MinimalRouterStateSnapshot extends BaseRouterStoreState {
  root: MinimalActivatedRouteSnapshot;
  url: string;
}

export class MinimalRouterStateSerializer
  implements RouterStateSerializer<MinimalRouterStateSnapshot>
{
  public readonly DATA_SERIALIZATION_DISABLED = { DATA_SERIALIZATION_DISABLED: true };

  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
  serialize(routerState: RouterStateSnapshot): MinimalRouterStateSnapshot {
    return {
      root: this.serializeRoute(<NgrxActivatedRouteSnapshot>routerState.root),
      url: routerState.url,
    };
  }

  private serializeRoute(route: NgrxActivatedRouteSnapshot): MinimalActivatedRouteSnapshot {
    const children = route.children.map(c => this.serializeRoute(c));
    const serializeData = route.routeConfig?.serializeData ?? true;
    return {
      params: route.params,
      data: serializeData ? route.data : this.DATA_SERIALIZATION_DISABLED,
      url: route.url,
      outlet: route.outlet,
      routeConfig: route.routeConfig
        ? {
            path: route.routeConfig.path,
            pathMatch: route.routeConfig.pathMatch,
            redirectTo: route.routeConfig.redirectTo,
            outlet: route.routeConfig.outlet,
          }
        : null,
      queryParams: route.queryParams,
      fragment: route.fragment,
      firstChild: children[0],
      children,
    };
  }
}
